<template>
    <div class="backlog-insights-tab">
        <details
            open
            class="backlog-overview"
            aria-labelledby="backlog-overview-header"
        >
            <summary>
                <h2 id="backlog-overview-header">
                    Backlog Overview
                </h2>
            </summary>
            <BacklogInsightsOverviewSection :query-params="queryParams" />
        </details>
        <details
            open
            class="backlog-analytics"
            aria-labelledby="backlog-analytics-header"
        >
            <summary>
                <h2 id="backlog-analytics-header">
                    Backlog Analytics
                </h2>
            </summary>
            <BacklogInsightsAnalyticsSection :query-params="queryParams" />
        </details>
    </div>
</template>

<script setup lang="ts">
import { toRef, watch } from 'vue';

import { ApiQueryParams } from '@/pages/OperationsInsights/types/ApiQueryParams';
import { useLogger } from '@agyletime/vue-3-common/src/composables/logger';
import BacklogInsightsOverviewSection from '@/pages/OperationsInsights/components/BacklogInsightsOverviewSection.vue';
import BacklogInsightsAnalyticsSection from '@/pages/OperationsInsights/components/BacklogInsightsAnalyticsSection.vue';

interface Props {
    queryParams: ApiQueryParams;
}

const props = defineProps<Props>();
const logger = useLogger('BacklogInsightsTab');
const queryParamsRef = toRef(props, 'queryParams');

watch(
    queryParamsRef,
    (newParams) => {
        logger.debug('queryParams changed', newParams);
    },
    { deep: true, immediate: true }
);
</script>

<style scoped lang="scss">
@use '../styles/backlog-insights-layout';
</style>

<style lang="scss">
.backlog-insights-tab {
    .grid-container {
        section {
            margin: 0;
            padding: 0;

            .grid-header {
                margin: 1rem 1rem 0.5rem;
                padding: 0;

                h3 {
                    margin-block: 0;
                }
            }
        }

        .grid .ag-root-wrapper {
            // Collapse the grid border into the card border
            border-bottom: 0;
            border-left: 0;
            border-right: 0;
            border-radius: 0;
        }

    }

    .chart-container {
        .chart-header {
            margin: 1rem 1rem;
            padding: 0;

            h3 {
                margin-block: 0;
            }
        }
    }
}
</style>
